export const toTimeString = (timestamp: Date): string => {
  return new Date(timestamp).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const toDateString = (timestamp: Date): string => {
  return new Date(timestamp).toLocaleDateString([], {
    month: 'long',
    day: '2-digit',
    year: 'numeric',
  })
}

export const toReadableTimestamp = (timestamp: Date): string => {
  return new Date(timestamp).toLocaleString([], {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const toYearMonthString = (timestamp: Date): string => {
  return new Date(timestamp).toLocaleString([], { month: 'long', year: 'numeric' })
}

export const calculateTimeDiff = (firstTimestamp: Date | null, secondTimestamp: Date | null): string => {
  if (!firstTimestamp || !secondTimestamp) {
    return 'N/A'
  }
  const difference = new Date(firstTimestamp).getTime() - new Date(secondTimestamp).getTime()
  return msToTime(difference)
}

export const msToTime = (msTimestamp: number): string => {
  const minutes = Math.floor(msTimestamp / 1000 / 60)
  const seconds = Math.floor((msTimestamp / 1000) % 60)
  return `${padZero(minutes)}:${padZero(seconds)}`
}

export const timeToMs = (time: string): number => {
  const minutes = time.split(':')[0]
  const seconds = time.split(':')[1]
  return parseInt(minutes) * 60 * 1000 + parseInt(seconds) * 1000
}

export const timeStringToLocal = (time: string) => {
  const timestamp = new Date(`1970-01-01T${time}`)
  return toTimeString(timestamp)
}

export const getDateString = (date: Date) => {
  const realDate = new Date(date)
  const offset = realDate.getTimezoneOffset()
  const dateWithoutTime = new Date(realDate.getTime() - offset * 60 * 1000)
  return dateWithoutTime.toISOString().split('T')[0]
}

const padZero = (num: number): string => {
  return ('00' + num).slice(-2)
}
